"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _Input = _interopRequireDefault(require("./Input"));
var _Menu = require("./Menu");
var _WebMenuItem = require("./WebMenuItem");
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _ArrowDropUp = _interopRequireDefault(require("@material-ui/icons/ArrowDropUp"));
var _lodash = _interopRequireDefault(require("lodash"));
var _styles = require("@material-ui/styles");
var _pittaModules = require("@thingsw/pitta-modules");
var _MobileMenu = require("./MobileMenu");
var _Typography = require("./Typography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    tnpDiv: {
      paddingLeft: 44
    },
    appIcon: {
      fontSize: 24,
      color: _pittaModules.LightColors.primary["7"]
      //  ux-ui프로젝트 디자인으로 아래css추가 , 전체적용(Leehj)
      // marginRight: theme.spacing(1),
    },

    mobileMemuItem: {
      padding: theme.spacing(1.5, 2)
    },
    arrowIcon: {
      color: _pittaModules.LightColors.primary["2"]
    }
  };
});
var Selector = function Selector(props) {
  var items = props.items,
    keyValue = props.keyValue,
    mobile = props.mobile,
    disabled = props.disabled,
    dense = props.dense,
    onChange = props.onChange,
    onClick = props.onClick,
    onType = props.onType,
    error = props.error,
    helperText = props.helperText,
    menuScrollTime = props.menuScrollTime,
    open = props.open,
    t = props.t,
    outlinedInputClassName = props.outlinedInputClassName,
    menuItemClassName = props.menuItemClassName,
    setting = props.setting,
    settingScroll = props.settingScroll,
    placeholder = props.placeholder,
    _props$select = props.select,
    select = _props$select === void 0 ? true : _props$select,
    paperClasses = props.paperClasses;
  var classes = useStyles();
  var anchorRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openMenuInternal = _useState2[0],
    setOpenMenuInternal = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    typeValue = _useState4[0],
    setTypeValue = _useState4[1];
  var openMenu = (0, _react.useMemo)(function () {
    if (open !== undefined) {
      return open;
    } else {
      return openMenuInternal;
    }
  }, [open, openMenuInternal]);
  (0, _react.useEffect)(function () {
    var _$find$value, _$find;
    var val = (_$find$value = (_$find = _lodash.default.find(items, function (item) {
      return item.key === keyValue;
    })) === null || _$find === void 0 ? void 0 : _$find.value) !== null && _$find$value !== void 0 ? _$find$value : items[0].value;
    if (val) {
      setTypeValue(val);
    }
  }, [items, keyValue, placeholder, t]);
  (0, _react.useEffect)(function () {
    if (onType && openMenuInternal) {
      setTimeout(function () {
        var _anchorRef$current;
        (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 || (_anchorRef$current = _anchorRef$current.querySelector("input")) === null || _anchorRef$current === void 0 ? void 0 : _anchorRef$current.focus();
      }, 100);
    }
  }, [onType, openMenuInternal]);
  var getValue = (0, _react.useCallback)(function (value) {
    if (value.includes("\n")) {
      var line1 = value.split("\n")[0];
      var line2 = value.split("\n")[1];
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t ? t(line1) : line1, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        variant: "Small",
        htmlColor: _pittaModules.LightColors.primary["2"]
      }, t ? t(line2) : line2));
    } else {
      return t ? t(value) : value;
    }
  }, [t]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Input.default, {
    outlinedInputClassName: outlinedInputClassName,
    rootRef: anchorRef,
    readOnly: onType ? false : true,
    select: true,
    active: openMenu,
    dense: dense,
    placeholder: placeholder,
    value: typeValue,
    disabled: disabled,
    error: error,
    helperText: openMenu ? "" : helperText
    // ux-ui 프로젝트 arrow아이콘 색상 적용(Leehj)
    ,
    endIcon: openMenuInternal ? /*#__PURE__*/_react.default.createElement(_ArrowDropUp.default, {
      className: (0, _clsx3.default)(_defineProperty({}, classes.arrowIcon, setting))
    }) : /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, {
      className: (0, _clsx3.default)(_defineProperty({}, classes.arrowIcon, setting))
    }),
    onChange: function onChange(e) {
      setTypeValue(e.target.value);
      onType === null || onType === void 0 ? void 0 : onType(e.target.value);
      if (!openMenuInternal) {
        setOpenMenuInternal(true);
      }
    },
    onClick: disabled ? undefined : function () {
      onClick === null || onClick === void 0 ? void 0 : onClick();
      setOpenMenuInternal(function (o) {
        return !o;
      });
    }
  }), !mobile && /*#__PURE__*/_react.default.createElement(_Menu.Menu, {
    paperClasses: paperClasses,
    settingScroll: settingScroll,
    select: select,
    menuScroll: menuScrollTime,
    open: openMenu,
    onClickAway: function onClickAway() {
      return setOpenMenuInternal(false);
    },
    anchorEl: anchorRef.current,
    placement: "bottom-end",
    modifiers: {
      offset: {
        enabled: true,
        offset: "0, 4px"
      }
    }
  }, _lodash.default.map(items, function (item) {
    if (item.key === "") {
      return;
    }
    return /*#__PURE__*/_react.default.createElement(_WebMenuItem.WebMenuItem, {
      key: "selector-menu-item-".concat(item.key),
      select: true,
      className: (0, _clsx3.default)({
        //  ux-ui프로젝트 디자인에는 앞에 공백이 없어서 해당 코드 주석,전체적용(Leehj)
        // [classes.tnpDiv]: keyValue !== item.key,
      }, menuItemClassName)
      // ux-ui프로젝트 endIcon으로 디자인되어있어서 변경, 전체적용(Leehj)
      ,
      endIcon: keyValue === item.key && /*#__PURE__*/_react.default.createElement(_Check.default, {
        className: classes.appIcon
      }),
      onClick: function onClick() {
        setOpenMenuInternal(false);
        onChange === null || onChange === void 0 ? void 0 : onChange(item);
        if (item.value.includes("\n")) {
          setTypeValue(item.value.split("\n")[0]);
        } else {
          setTypeValue(item.value);
        }
      }
    }, getValue(item.value));
  })), mobile && /*#__PURE__*/_react.default.createElement(_MobileMenu.MobileMenu, {
    open: openMenu,
    onClose: function onClose() {
      return setOpenMenuInternal(false);
    }
  }, _lodash.default.map(items, function (item) {
    return /*#__PURE__*/_react.default.createElement(_WebMenuItem.WebMenuItem, {
      key: "selector-menu-item-".concat(item.key),
      className: classes.mobileMemuItem,
      endIcon: keyValue === item.key && /*#__PURE__*/_react.default.createElement(_Check.default, {
        className: classes.appIcon
      }),
      onClick: function onClick() {
        setOpenMenuInternal(false);
        onChange === null || onChange === void 0 ? void 0 : onChange(item);
      }
    }, t ? t(item.value) : item.value);
  })));
};
exports.Selector = Selector;